import { create } from "zustand";
import { api } from "@/services/api.service";
import { persist } from "zustand/middleware";

export type IData = {
  balance: number;
  bonusBalance: number;
  nativeBalance: number;
  hold: boolean;
  setBalance: (balance: number) => void;
  setBonusBalance: (balance: number) => void;
  setNativeBalance: (balance: number) => void;
  setHold: (hold: boolean) => void;
  refreshBalance: () => void;
  forceRefreshBalance: () => void;
};

const useBalanceStore = create<IData>()(
  persist(
    (set) => ({
      balance: 0,
      bonusBalance: 0,
      nativeBalance: 0,
      hold: false,
      setBalance: (balance: number) => {
        set({ balance });
      },
      setBonusBalance: (balance: number) => {
        set({ bonusBalance: balance });
      },
      setNativeBalance: (balance: number) => {
        set({ nativeBalance: balance });
      },
      refreshBalance: () => {
        if (useBalanceStore.getState().hold) return;
        api
          .get("/profile/account")
          .then((response) => {
            set({
              balance: response?.data?.data.balance,
              bonusBalance: response?.data?.data.bonusBalance,
              nativeBalance: response?.data?.data.nativeBalance,
            });
          })
          .catch((error) => {
            console.log(error);
          });
      },
      forceRefreshBalance: () => {
        api
          .get("/profile/account")
          .then((response) => {
            set({
              balance: response?.data?.data.balance,
              bonusBalance: response?.data?.data.bonusBalance,
              nativeBalance: response?.data?.data.nativeBalance,
            });
          })
          .catch((error) => {
            console.log(error);
          });
      },
      setHold: (hold: boolean) => {
        if (!hold) useBalanceStore.getState().refreshBalance();
        set({ hold });
      },
    }),
    {
      name: "balance-store",
    },
  ),
);
export default useBalanceStore;
